<template>
  <div class="container" style="width:99%;margin-top:-25px;">
    <!--工具栏-->
    <div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
      <div class="filter-bar">
        <el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
          <el-form-item style="margin-bottom:0;" class="filter-item">
            <SearchWhseClient ref="searchWhseClient" :whId="filters.whId" :clientCode="filters.clientCode" @search-whse-event="getSearchWhseClient(arguments)" perms="sys:rfMainProcessDetail:view" type="primary"/>
          </el-form-item>
          <el-form-item style="margin-bottom:0;" class="filter-item">
            <el-select ref="subProcessName" v-model="filters.subProcessName" :placeholder="$t('RfSubProcessDetail.subProcessName')" size="small" style="width: 150px;">
              <el-option :label="$t('RfSubProcessDetail.option.any')" value="%"></el-option>
              <el-option v-for="(name, index) in subProcessNames" :key="index" :value="name" :label="name"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="action-bar">
        <kt-button :label="$t('action.search')" perms="sys:rfMainProcessDetail:view" type="primary" icon="el-icon-search" @click="findPage(null)"/>
        <kt-button :label="$t('action.add')" perms="sys:rfMainProcessDetail:add" type="primary" icon="el-icon-plus" @click="handleAdd"/>
        <kt-button :label="$t('action.addProcessResource')" perms="sys:rfMainProcessDetail:add" type="primary" icon="el-icon-plus" @click="addProcessResource"/>
        <kt-button :label="$t('action.addFunctionKey')" perms="sys:rfMainProcessDetail:add" type="primary" icon="el-icon-plus" @click="addFunctionKey"/>
      </div>
    </div>
    <!--表格内容栏-->
    <el-table :data="pageResult.content" :highlight-current-row="highlightCurrentRow" @selection-change="selectionChange"
              @current-change="handleCurrentChange" v-loading="loading" :element-loading-text="$t('action.loading')" :border="border" :stripe="stripe"
              :show-overflow-tooltip="showOverflowTooltip" :max-height="maxHeight" :height="height" :size="size" :align="align" style="width:100%;">
      <el-table-column v-for="column in columns" :key="column.prop" :prop="column.prop" :label="$t(column.label)" :width="column.width" :min-width="column.minWidth">
        <template slot-scope="scope">
          <el-link v-if="['dialogTitle', 'dialogHeader1', 'dialogHeader2', 'dialogHeader3', 'dialogHeader4', 'dialogHeader5', 'dialogPrompt', 'dialogOptionName'].includes(column.prop)"
                    type="primary" :underline="false" @click="handleCellClick(scope.row, column.prop)">
            {{ scope.row[column.prop] }}
          </el-link>
          <span v-else>{{ scope.row[column.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('action.operation')" width="70" header-align="center" fixed="right" align="left">
        <template slot-scope="scope">
          <div style="padding-top:2px;">
            <kt-button icon="fa fa-edit" :label="$t('action.edit')" perms="sys:rfMainProcessDetail:edit" size="mini" @click="handleEdit(scope.row)" />
          </div>
          <div style="padding-top:2px;">
            <kt-button icon="fa fa-trash" :label="$t('action.delete')" perms="sys:rfMainProcessDetail:delete" size="mini" type="danger" @click="handleDelete(scope.row)" />
          </div>
          <div style="padding-top:2px;">
            <kt-button icon="fa fa-copy" :label="$t('action.copy')" perms="sys:rfMainProcessDetail:add" size="mini" @click="handleCopy(scope.row)" />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--新增编辑界面-->
    <el-dialog :title="operation ? $t('common.add') : $t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
      <el-form :model="dataForm" label-width="110px" :rules="dataFormRules" ref="dataForm" :size="size">
        <el-form-item label="" prop="id" v-if="false">
          <el-input v-model="dataForm.id" auto-complete="off"></el-input>
        </el-form-item>
        <EditWhseClient ref="editWhseClient" @edit-whse-event="getEditWhseClient(arguments)" :whId="dataForm.whId" :clientCode="dataForm.clientCode" perms="sys:rfMainProcessDetail:view" type="primary" :disabled="!operation"/>
        <el-form-item :label="$t('RfSubProcessDetail.subProcessName')" prop="subProcessName">
          <el-input v-model="dataForm.subProcessName" auto-complete="off" :disabled="!operation"></el-input>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.processVersion')" prop="processVersion">
          <el-input v-model="dataForm.processVersion" auto-complete="off" :disabled="false"></el-input>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.processDescription')" prop="processDescription">
          <el-input v-model="dataForm.processDescription" auto-complete="off" :disabled="false"></el-input>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogTitle')" prop="dialogTitle">
          <el-select v-model="dataForm.dialogTitle" @focus="fetchProcessResources('title')" :disabled="false" style="width: 100%;">
            <el-option v-for="(item, index) in titleOptions" :key="index" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogHeader1')" prop="dialogHeader1">
          <el-select v-model="dataForm.dialogHeader1" @focus="fetchProcessResources('header')" :disabled="false" style="width: 100%;">
            <el-option value="" label="无"></el-option>
            <el-option v-for="(item, index) in headerOptions" :key="index" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogHeader2')" prop="dialogHeader2">
          <el-select v-model="dataForm.dialogHeader2" @focus="fetchProcessResources('header')" :disabled="false" style="width: 100%;">
            <el-option value="" label="无"></el-option>
            <el-option v-for="(item, index) in headerOptions" :key="index" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogHeader3')" prop="dialogHeader3">
          <el-select v-model="dataForm.dialogHeader3" @focus="fetchProcessResources('header')" :disabled="false" style="width: 100%;">
            <el-option value="" label="无"></el-option>
            <el-option v-for="(item, index) in headerOptions" :key="index" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogHeader4')" prop="dialogHeader4">
          <el-select v-model="dataForm.dialogHeader4" @focus="fetchProcessResources('header')" :disabled="false" style="width: 100%;">
            <el-option value="" label="无"></el-option>
            <el-option v-for="(item, index) in headerOptions" :key="index" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogHeader5')" prop="dialogHeader5">
          <el-select v-model="dataForm.dialogHeader5" @focus="fetchProcessResources('header')" :disabled="false" style="width: 100%;">
            <el-option value="" label="无"></el-option>
            <el-option v-for="(item, index) in headerOptions" :key="index" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item :label="$t('RfSubProcessDetail.dialogPrompt')" prop="dialogPrompt">
          <el-select v-model="dataForm.dialogPrompt" @focus="fetchProcessResources('prompt')" :disabled="false" style="width: 100%;">
            <el-option value="" label="无"></el-option>
            <el-option v-for="(item, index) in promptOptions" :key="index" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogInputDefault')" prop="dialog_input_default">
          <el-input v-model="dataForm.dialogInputDefault" auto-complete="off" :disabled="!operation"></el-input>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogInputField')" prop="dialog_input_field">
          <el-input v-model="dataForm.dialogInputField" auto-complete="off" :disabled="false"></el-input>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogListSourceExecSp')" prop="dialog_list_source_exec_sp">
          <el-input v-model="dataForm.dialogListSourceExecSp" auto-complete="off" :disabled="false"></el-input>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogListField')" prop="dialog_list_field">
          <el-input v-model="dataForm.dialogListField" auto-complete="off" :disabled="false"></el-input>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogOptionName')" prop="dialog_option_name">
          <el-select v-model="dataForm.dialogOptionName" @focus="fetchProcessResources('option')" :disabled="false" style="width: 100%;">
            <el-option :value="null" :label="$t('RfSubProcessDetail.option.empty')"/>
            <el-option v-for="(item, index) in optionOptions" :key="index" :value="item">{{ item }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('RfSubProcessDetail.dialogExecSp')" prop="dialog_exec_sp">
          <el-input v-model="dataForm.dialogExecSp" auto-complete="off" :disabled="false"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
        <el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/views/Core/KtButton"
import SearchWhseClient from "@/views/Core/SearchWhseClient"
import EditWhseClient from "@/views/Core/EditWhseClient"
import { format } from "@/utils/datetime"

export default {
  name: 'RfSubProcessDetail',
  components: {
    KtButton,
    SearchWhseClient,
    EditWhseClient
  },
  data() {
    return {
      size: 'small',
      filters: {
        whId: '',
        clientCode: '',
        subProcessName: ''
      },
      subProcessNames: [],
      titleOptions: [],
      headerOptions: [],
      promptOptions: [],
      optionOptions: [],
      columns: [
        {prop:"id", label:"RfSubProcessDetail.id", minWidth:100},
        {prop:"whId", label:"RfSubProcessDetail.whId", minWidth:100},
        {prop:"clientCode", label:"RfSubProcessDetail.clientCode", minWidth:100},
        {prop:"subProcessName", label:"RfSubProcessDetail.subProcessName", minWidth:100},
        {prop:"processVersion", label:"RfSubProcessDetail.processVersion", minWidth:100},
        {prop:"processDescription", label:"RfSubProcessDetail.processDescription", minWidth:100},
        {prop:"dialogTitle", label:"RfSubProcessDetail.dialogTitle", minWidth:100},
        {prop:"dialogHeader1", label:"RfSubProcessDetail.dialogHeader1", minWidth:100},
        {prop:"dialogHeader2", label:"RfSubProcessDetail.dialogHeader2", minWidth:100},
        {prop:"dialogHeader3", label:"RfSubProcessDetail.dialogHeader3", minWidth:100},
        {prop:"dialogHeader4", label:"RfSubProcessDetail.dialogHeader4", minWidth:100},
        {prop:"dialogHeader5", label:"RfSubProcessDetail.dialogHeader5", minWidth:100},
        {prop:"dialogPrompt", label:"RfSubProcessDetail.dialogPrompt", minWidth:100},
        {prop:"dialogInputDefault", label:"RfSubProcessDetail.dialogInputDefault", minWidth:100},
        {prop:"dialogInputField", label:"RfSubProcessDetail.dialogInputField", minWidth:100},
        {prop:"dialogListSourceExecSp", label:"RfSubProcessDetail.dialogListSourceExecSp", minWidth:100},
        {prop:"dialogListField", label:"RfSubProcessDetail.dialogListField", minWidth:100},
        {prop:"dialogOptionName", label:"RfSubProcessDetail.dialogOptionName", minWidth:100},
        {prop:"dialogExecSp", label:"RfSubProcessDetail.dialogExecSp", minWidth:100},
        {prop:"createTime", label:"RfSubProcessDetail.createTime", minWidth:100},
        {prop:"updateTime", label:"RfSubProcessDetail.updateTime", minWidth:100}
      ],
      pageRequest: { pageNum: 1, pageSize: 100 },
      pageResult: {},
      operation: false,
      editDialogVisible: false,
      editLoading: false,
      dataFormRules: {
        subProcessName: [
          { required: true, message: this.$t('RfSubProcessDetail.dataFormRules.subProcessName'), trigger: 'blur' }
        ],
        processVersion: [
          { required: true, message: this.$t('RfSubProcessDetail.dataFormRules.processVersion'), trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: this.$t('RfSubProcessDetail.dataFormRules.processVersionNumeric'), trigger: 'blur' }
        ],
        dialogTitle: [
          { required: true, message: this.$t('RfSubProcessDetail.dataFormRules.dialogTitle'), trigger: 'blur' }
        ],
        dialogPrompt: [
          { required: true, message: this.$t('RfSubProcessDetail.dataFormRules.dialogPrompt'), trigger: 'blur' }
        ]
      },
      dataForm: {
        id: null,
        whId: null,
        clientCode: null,
        subProcessName: null,
        processVersion: null,
        processDescription: null,
        dialogTitle: null,
        dialogHeader1: null,
        dialogHeader2: null,
        dialogHeader3: null,
        dialogHeader4: null,
        dialogHeader5: null,
        dialogPrompt: null,
        dialog_input_default: null,
        dialog_input_field: null,
        dialog_list_source_exec_sp: null,
        dialog_list_field: null,
        dialog_option_name: null,
        dialog_exec_sp: null
      },
      maxHeight: 520,
      height: 520
    }
  },
  methods: {
    fetchProcessResources(type) {
      this.$wmsApi.rfProcessResource.getProcessResources({ type }).then(res => {
        if (res.code === 200) {
          if (type === 'title') {
            this.titleOptions = res.data; // 假设返回的数据是一个数组
          }
else if (type === 'header') {
            this.headerOptions = res.data;
          }
else if (type === 'prompt') {
            this.promptOptions = res.data;
          }
else if (type === 'option') {
            this.optionOptions = res.data;
          }
        }
else {
          this.$message({ message: res.msg, type: 'error' });
        }
      }).catch(error => {
        console.error("Error fetching process resources:", error);
      });
    },
    getSearchWhseClient: function (data) {
      this.filters.whId = data[0]
      this.filters.clientCode = data[1]
      this.getSubProcessNames(data[0], data[1])
    },
    getEditWhseClient: function (data) {
      this.dataForm.whId = data[0]
      this.dataForm.clientCode = data[1]
      this.getSubProcessNames(data[0], data[1])
    },
    getSubProcessNames: function (whId, clientCode) {
      this.$wmsApi.rfSubProcessDetail.getSubProcessNames({ whId, clientCode }).then((res) => {
        this.subProcessNames = res.data
      })
    },
    findPage: function (data) {
      if(data !== null && data.pageRequest) {
				this.pageRequest.pageNum = data.pageRequest.pageNum
				this.pageRequest.pageSize = data.pageRequest.pageSize
			}
			let whId = this.filters.whId
      let clientCode = this.filters.clientCode
      let subProcessName = this.filters.subProcessName
      this.pageRequest.columnFilters = {
        whId: {name:'whId', value:whId},
        clientCode: {name:'clientCode', value:clientCode},
        subProcessName: {name:'subProcessName', value:subProcessName}
      }
this.$wmsApi.rfSubProcessDetail.findPage(this.pageRequest).then((res) => {
        this.pageResult = res.data
      })
    },
    handleEdit: function (row) {
      this.editDialogVisible = true
      this.operation = true
      this.dataForm = Object.assign({}, row)
    },
    handleDelete: function (row) {
      this.$confirm(this.$t("common.message.confirmDelete"), this.$t("common.message.prompt"), {
        confirmButtonText: this.$t("common.message.confirm"),
        cancelButtonText: this.$t("common.message.cancel"),
        type: 'warning'
      }).then(() => {
        this.$wmsApi.rfSubProcessDetail.batchDelete(row).then(res => {
          if (res.code === 200) {
            this.$message({ message: this.$t("common.message.success"), type: 'success' });
            this.findPage(null);
          }
else {
            this.$message({ message: this.$t("common.message.fail") + res.msg, type: 'error' });
          }
        });
      });
    },
    handleCellClick: function (row, prop) {
      if (prop === 'dialogOptionName') {
        this.$router.push({
          path: "/Wms/RfSubProcessOption",
          query: {
            whId: row.whId,
            clientCode: row.clientCode,
            subProcessName: row.subProcessName,
            dialogOptionName: row.dialogOptionName,
            date: new Date().getTime()
          }
        });
      }
else {
        this.$router.push({
          path: "/Wms/RfProcessResourceDetail",
          query: {
            name: row[prop],
            type: '%',
            date: new Date().getTime()
          }
        });
      }
    },
    addProcessResource() {
      this.$router.push({
        path: "/Wms/RfProcessResourceDetail",
        query: {
          name: '%', // 传入的参数为 %
          type: '%',
          date: new Date().getTime()
        }
      });
    },
    handleAdd() {
      this.editDialogVisible = true
      this.operation = true
      this.dataForm = {
        id: null,
        whId: this.filters.whId,
        clientCode: this.filters.clientCode,
        subProcessName: null,
        processVersion: null,
        processDescription: null,
        dialogTitle: null,
        dialogHeader1: null,
        dialogHeader2: null,
        dialogHeader3: null,
        dialogHeader4: null,
        dialogHeader5: null,
        dialogPrompt: null,
        dialogInputDefault: null,
        dialogInputField: null,
        dialogListSourceExecSp: null,
        dialogListField: null,
        dialogOptionName: null,
        dialogExecSp: null
      }
    },
    handleCopy(row) {
      this.editDialogVisible = true
      this.operation = true
      this.dataForm = {
        id: null,
        whId: row.whId,
        clientCode: row.clientCode,
        subProcessName: row.subProcessName,
        processVersion: row.processVersion,
        processDescription: row.processDescription,
        dialogTitle: row.dialogTitle,
        dialogHeader1: row.dialogHeader1,
        dialogHeader2: row.dialogHeader2,
        dialogHeader3: row.dialogHeader3,
        dialogHeader4: row.dialogHeader4,
        dialogHeader5: row.dialogHeader5,
        dialogPrompt: row.dialogPrompt,
        dialogInputDefault: row.dialogInputDefault,
        dialogInputField: row.dialogInputField,
        dialogListSourceExecSp: row.dialogListSourceExecSp,
        dialogListField: row.dialogListField,
        dialogOptionName: row.dialogOptionName,
        dialogExecSp: row.dialogExecSp
      }
    },
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          // 校验 whId 和 clientCode
          if (!this.dataForm.whId || !this.dataForm.clientCode) {
            this.$message({ message: this.$t("common.message.requiredFields"), type: 'warning' });
            return;
          }
this.editLoading = true;
          this.$wmsApi.rfSubProcessDetail.save(this.dataForm).then(res => {
            if (res.code === 200) {
              this.$message({ message: this.$t("common.message.success"), type: 'success' });
              this.editDialogVisible = false;
              this.findPage(null);
              this.getSubProcessNames(this.filters.whId, this.filters.clientCode);
            }
else {
              this.$message({ message: this.$t("common.message.fail") + res.msg, type: 'error' });
            }
this.editLoading = false;
          }).catch(error => {
            this.editLoading = false;
            this.$message({ message: this.$t("common.message.fail") + (error.message || ''), type: 'error' });
          });
        }
      });
    },
    addFunctionKey() {
      if (!this.filters.whId || !this.filters.clientCode || !this.filters.subProcessName) {
        this.$message({ message: this.$t("common.message.requiredFields"), type: 'warning' });
        return;
      }
this.$router.push({
        path: "/Wms/RfSubProcessOption",
        query: {
          whId: this.filters.whId,
          clientCode: this.filters.clientCode,
          subProcessName: this.filters.subProcessName,
          dialogOptionName: '%',
          date: new Date().getTime()
        }
      });
    }
  },
  //每次刷新页面都会触发
  activated() {
    // 获取路由参数
    const { whId, clientCode, subProcessName } = this.$route.query;
    // 设置 filters
    if (whId!==undefined) {
      this.filters.whId = whId || ''; // 默认值为空字符串
    }
if (clientCode!==undefined) {
      this.filters.clientCode = clientCode || ''; // 默认值为空字符串
    }
if (subProcessName!==undefined) {
      this.filters.subProcessName = subProcessName || ''; // 默认值为空字符串
    }
    
    // 增加判断，只有在三个参数都不为空时才调用 findPage
    if (this.filters.whId && this.filters.clientCode && this.filters.subProcessName) {
        this.findPage(null);
    }
  }
}
</script>

<style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}

/* 固定列左侧隔断阴影线 */
/deep/ .el-table__fixed-right::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 10px;
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/RfSubProcessDetail.vue